<div class="modal-header">
  <h6 class="modal-title" id="modal-basic-title">{{"Update Mobile Number"|translate}}</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()">
  </button>
</div>
<div class="modal-body">
  <div class="bg-form-content p-4">
    <form class="change-password-form" ngForm [formGroup]="updateForm" novalidate>
      <div class="field-group mb-3">
        <label>{{"Current Mobile Number"|translate}}</label>
        <input type="text" name="old_mobile_number" formControlName="old_mobile_number"
          class="form-control light-mode-form" [mask]="US_PHONE_MASKING"
          [readonly]="show.newMobileNumberOTPfield || show.oldMobileNumberOTPfield" />
        <val-errors controlName="old_mobile_number">
          <ng-template valError="invalidPhoneNumber">
            <small class="form-error text-danger">
              {{"Current Mobile Number is not well formed"|translate}}.
            </small>
          </ng-template>
          <ng-template valError="required">
            <small class="form-error text-danger">
              {{"Please enter current mobile number"|translate}}.
            </small>
          </ng-template>
        </val-errors>
      </div>
      <div class="field-group mb-3">
        <label>{{"New Mobile Number"|translate}}</label>&nbsp;
        <!-- <small class="lms-text-light-green" *ngIf="!show.verifyNewMobileNumber">
          {{ "verified" | translate }}
        </small> -->
        <input type="text" name="new_mobile_number" formControlName="new_mobile_number"
          class="form-control light-mode-form" [mask]="US_PHONE_MASKING"
          [readonly]="show.newMobileNumberOTPfield || show.oldMobileNumberOTPfield" />
        <val-errors controlName="new_mobile_number">
          <ng-template valError="invalidPhoneNumber">
            <small class="form-error text-danger">
              {{"New Mobile Number is not well formed"|translate}}.
            </small>
          </ng-template>
          <ng-template valError="required">
            <small class="form-error text-danger">
              {{"Please enter new mobile number"|translate}}.
            </small>
          </ng-template>
        </val-errors>
        <small class="form-error text-danger"
          *ngIf="updateForm.get('new_mobile_number')?.valid &&
            updateForm.get('old_mobile_number')?.valid && updateForm.value?.new_mobile_number == updateForm.value?.old_mobile_number">
          {{"Your new mobile number must be different from your old mobile number"|translate}}.
        </small>
      </div>
      <div class="field-group mb-3" *ngIf="show.newMobileNumberOTPfield">
        <label>{{"Enter Verification Code"|translate}}</label>
        <ng-otp-input formControlName="new_mobile_number_otp" [config]="config"></ng-otp-input>
        <div class="text-muted">
          <small *ngIf="countdown > 0">
            {{"Didn't get the OTP?"|translate}} {{ "Resend in" | translate }} {{ countdown }}s
          </small>
          <a href="javascript:void(0)" (click)="getOTP('new-mobile-number')" *ngIf="countdown === 0">
            <small>{{ "Resend OTP" | translate }}</small>
          </a>
        </div>
      </div>
      <div class="field-group mb-3" *ngIf="show.oldMobileNumberOTPfield">
        <p *ngIf="userInfo.mfa_type=='APP'">
          {{'Enter the code from your two-factor authenticator app'|translate}}.
        </p>
        <p *ngIf="userInfo.mfa_type=='SMS'">
          {{'Please enter verification code sent to your mobile number'|translate}} {{userInfo?.masked_mobile_number}}.
        </p>
        <label>{{"Verification Code"|translate}}</label>
        <ng-otp-input formControlName="old_mobile_number_otp" [config]="config"></ng-otp-input>
        <div class="text-muted" *ngIf="userInfo?.mfa_type!='APP'">
          <small *ngIf="countdown > 0">
            {{"Didn't get the OTP?"|translate}} {{ "Resend in" | translate }} {{ countdown }}s
          </small>
          <a href="javascript:void(0)" (click)="getOTP()" *ngIf="countdown === 0">
            <small>{{ "Resend OTP" | translate }}</small>
          </a>
        </div>
      </div>
      <div>
        <small class="form-error text-danger" *ngIf="messageData?.errorArr?.length">
          <div *ngFor="let item of messageData?.errorArr; let i=index;" class="mt-3">
            <li>{{item}}</li>
          </div>
        </small>
        <small class="lms-text-light-green" *ngIf="messageData?.verified">
          <li class="fs-15">
            {{messageData.verified}}
            <ng-container *ngIf="redirectData?.message">
              {{redirectData.message}}{{redirectData.countdown}}s.
            </ng-container>
          </li>
        </small>
      </div>
      <!-- <div class="mt-3" *ngIf="show.verifyNewMobileNumber && !show.newMobileNumberOTPfield">
        <button class="btn btn-primary d-block w-100 text-uppercase" (click)="getOTP('new-mobile-number')">
          {{"Verify New Mobile Number"|translate}}
        </button>
      </div> -->
      <div class="mt-3" *ngIf="!show.oldMobileNumberOTPfield">
        <button class="btn btn-primary d-block w-100 text-uppercase" (click)="getOTP()">
          {{"Update Mobile Number"|translate}}
        </button>
      </div>
      <div class="mt-3" *ngIf="!show.verifyOldMobileNumberOTP">
        <button class="btn btn-primary d-block w-100 text-uppercase" (click)="onSubmit()"
          [disabled]="updateForm.controls.old_mobile_number_otp.invalid || redirectData.message">
          {{"Update Mobile Number"|translate}}
        </button>
      </div>
    </form>
  </div>
</div>